module.exports = __webpack_public_path__ + "media/ר.8f96b01d.mp3";